<!-- Messages panel — profile redesign (design_handoff_profile_redesign §7).
     Presentation is composed from @viewbid/ui: panel header, message ledger
     table (owns the unread dot, row/kebab interactions, and the "No messages."
     empty state), read/unread legend, and the shared paginator bar. -->
<div class="messages-panel">
    <vb-panel-header
        title="Messages"
        subtitle="Replies from sellers to your lot questions.">
    </vb-panel-header>

    <div *ngIf="isLoading; else panelBody" class="vb-spinner-box vb-spinner-box--panel">
        <vb-spinner size="xl" label="Loading messages"></vb-spinner>
    </div>

    <ng-template #panelBody>
        <!-- Top pagination lockup — summary + per-page 10/25/50 + nav,
             mirroring the My-bidding panel. -->
        <vb-paginator-bar
            *ngIf="rows.length > 0"
            variant="top"
            label="messages"
            [dense]="isMobile"
            [current]="paginate.currentPage ?? 1"
            [total]="paginate.totalPages ?? 0"
            [totalItems]="paginate.totalItems ?? 0"
            [perPage]="pageSize"
            [perPageOptions]="pageSizeOptions"
            (pageChange)="setPage($event)"
            (perPageChange)="setPageSize($event)">
        </vb-paginator-bar>

        <vb-message-table
            [rows]="rows"
            [menuItems]="rowMenuItems"
            (rowClick)="onRowClick($event)"
            (menuSelect)="onRowMenuSelect($event)">
        </vb-message-table>

        <!-- Footer: legend left, bare pager right (per-page lives in the
             top bar) -->
        <div class="messages-panel__footer">
            <vb-legend [items]="legendItems"></vb-legend>
            <vb-paginator
                *ngIf="rows.length > 0"
                [current]="paginate.currentPage ?? 1"
                [total]="paginate.totalPages ?? 0"
                [labels]="false"
                [dense]="isMobile"
                (pageChange)="setPage($event)">
            </vb-paginator>
        </div>
    </ng-template>

    <!-- Thread dialog — vb-message-thread composes the vb-dialog shell.
         Placed BEFORE the delete confirm: both scrims share a z-index, so
         DOM order keeps the confirm on top when delete is triggered from
         inside the open thread. -->
    <vb-message-thread
        [open]="threadOpen"
        [topic]="threadComment?.topic"
        [topicLabel]="threadComment?.topicLabel"
        [topicId]="threadComment?.topicId"
        [accountMappingsId]="threadComment?.accountMappingsId"
        [invoiceId]="threadComment?.invoiceId"
        [auctionId]="threadComment?.auctionId"
        [lotId]="threadComment?.lotId"
        (closed)="onThreadClosed()"
        (deleteConversation)="deleteConversation($event)" />

    <!-- Delete-conversation confirm — vb-dialog with the same translated
         copy the legacy ngx-bootstrap confirmation window showed. -->
    <vb-dialog
        [open]="deleteConfirmOpen"
        tone="danger"
        [title]="deleteConfirmTitle"
        (closed)="closeDeleteConfirm()">
        <p class="messages-panel__confirm-copy">{{ deleteConfirmMessage }}</p>
        <p class="messages-panel__confirm-warning">
            {{ deleteConfirmWarning }}
        </p>
        <!-- vb-dialog's footer slot stacks children (its full-width recipe);
             a single row wrapper keeps Cancel/Confirm side by side. -->
        <div class="messages-panel__confirm-actions" dialogFooter>
            <vb-button
                variant="ghost"
                [fullWidth]="true"
                (clicked)="closeDeleteConfirm()">
                Cancel
            </vb-button>
            <vb-button
                variant="primary"
                [fullWidth]="true"
                (clicked)="onDeleteConfirmed()">
                {{ deleteConfirmLabel }}
            </vb-button>
        </div>
    </vb-dialog>
</div>
